/* src/app/code/code.component.scss */
a:hover {
  cursor: pointer;
}
a:not([href]):not([tabeindex]) {
  text-decoration: underline;
}
.mat-mdc-cell {
  text-align: left;
}
.mat-column-active {
  width: 55px;
  max-width: 55px;
  padding-right: 10px;
}
.mat-column-active ::ng-deep .mat-checkbox-checked .mat-checkbox-background,
.mat-column-active ::ng-deep .mat-checkbox-indeterminate .mat-checkbox-background {
  background-color: #666 !important;
}
.mat-column-active ::ng-deep .mat-checkbox-frame {
  border-color: #666 !important;
}
.mat-column-code {
  max-width: 100px;
}
.mat-column-expected_completion {
  max-width: 120px;
}
.mat-column-user_count {
  max-width: 80px;
}
.mat-column-stencil {
  max-width: 80px;
}
.mat-column-completion {
  max-width: 90px;
}
.mat-column-expiry {
  max-width: 120px;
}
.mat-column-expected_users {
  max-width: 80px;
}
.autoAdd {
  margin-top: 50px;
  border-top: 1px solid #fefefe;
  text-align: left;
  padding: 40px;
}
.mat-mdc-row:hover {
  background-color: darkgray;
  color: black;
}
.mat-mdc-row {
  border-color: #605959;
}
h2 {
  text-align: right;
  padding-right: 20px;
  margin-top: -20px;
}
.opposite {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.opposite .client-name {
  font-size: 1.5rem;
}
.menu {
  display: flex;
  padding-top: 20px;
}
.menu input {
  line-height: 2rem;
}
.menu div {
  margin-left: 10px;
}
.mat-mdc-row {
  position: relative !important;
}
.mat-mdc-cell {
  align-self: center;
}
.mat-column-actions {
  flex: 0 0 60px !important;
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px !important;
  overflow: visible !important;
}
.action-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-trigger {
  opacity: 0;
  transition: opacity 0.2s;
  background: transparent !important;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  min-width: unset !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.menu-trigger .mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #757575;
}
.menu-trigger:hover,
.menu-trigger.active {
  background-color: rgba(0, 0, 0, 0.04) !important;
  opacity: 1 !important;
}
.menu-trigger {
  text-decoration: none !important;
}
.mat-mdc-row:hover .menu-trigger {
  opacity: 1;
}
.row-toolbar {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 5px 0;
  min-width: 140px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-50%) scale(0.95);
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0s linear 0.25s;
}
.row-toolbar.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) scale(1);
  transition-delay: 0s;
}
.row-toolbar.visible .action-btn {
  opacity: 1;
  transition: opacity 0.25s ease;
}
.action-btn {
  display: block;
  padding: 8px 16px;
  background-color: transparent;
  border: none;
  font-size: 13px;
  color: #333 !important;
  text-decoration: none !important;
  cursor: pointer;
  white-space: nowrap;
  text-align: left;
  line-height: normal;
  opacity: 0;
  transition: opacity 0.1s ease;
}
.action-btn:hover {
  background-color: #f5f5f5;
  color: black !important;
}
.action-btn {
  margin: 0;
  border-bottom: none;
  border-radius: 0;
}
.duplicate-code-modal {
  background: white;
  border-radius: 6px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.duplicate-code-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 24px 14px;
  border-bottom: 1px solid #e0e0e0;
}
.duplicate-code-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.duplicate-code-close {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
  padding: 2px 4px;
}
.duplicate-code-close:hover {
  color: #333;
}
.duplicate-code-body {
  padding: 16px 24px;
  color: #333;
}
.duplicate-code-body p {
  font-size: 13px;
  margin-bottom: 10px;
}
.duplicate-code-body p.duplicate-code-error {
  background: #fdecea;
  border: 1px solid #f5c6cb;
  color: #c0392b;
  border-radius: 4px;
  padding: 8px 10px;
  margin-top: 10px;
  margin-bottom: 0;
}
.duplicate-code-select-field {
  width: 100%;
  font-size: 13px;
}
.duplicate-code-select-field ::ng-deep .mat-mdc-text-field-wrapper {
  background: white;
}
.duplicate-code-select-field ::ng-deep .mat-mdc-form-field-infix {
  min-height: unset;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 4px;
}
.duplicate-code-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 24px 20px;
  border-top: 1px solid #e0e0e0;
}
.duplicate-code-cancel {
  border: 1px solid #333;
  background: white;
  color: #333;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.duplicate-code-cancel:hover {
  background: #f5f5f5;
}
.duplicate-code-confirm {
  border: 1px solid #3f47cc;
  background: #3f47cc;
  color: white;
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.duplicate-code-confirm:hover {
  background: #353db5;
}
.duplicate-code-confirm:disabled {
  background: #bdbdbd;
  border-color: #bdbdbd;
  cursor: default;
}
.flash-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 1000;
  font-size: 1.2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  animation: fadeinout 1.5s forwards;
}
.flash-message mat-icon {
  color: #4caf50;
  width: 30px;
  height: 30px;
  font-size: 30px;
}
@keyframes fadeinout {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
/*# sourceMappingURL=code.component.css.map */
